import React, { useState } from "react";

import api from "../services/api";

import Popup from "./Popup";
import SocialMediaUser from "./SocialMediaUser";
import LoadingCenter from "../components/LoadingCenter";

//hooks
import { useForm } from "react-hook-form";
import { useAuth } from "../providers/auth";

//SVG's
import Facebook from "../svgs/Facebook";
import WhatsApp from "../svgs/WhatsApp";
import Telegram from "../svgs/Telegram";
import Instagram from "../svgs/Instagram";

const PopupSocialMediaUserId = ({ trigger, socialMedias, setTrigger, setSelectedMedia, idCustomer, fetchMessagesById, handleChatBack, blockLongPooling }) => {
  const { user } = useAuth();
  const { register, handleSubmit } = useForm();

  const onSubmit = data => {
    setSelectedMedia(data.social_media);
    startNovoChat(data.social_media);
    setTrigger(false);
    blockLongPooling.current = false;
  };

  function getMediaType(media) {
    switch (media) {
      case "Whatsapp":
        return <WhatsApp />;

      case "Instagram":
        return <Instagram />;

      case "Facebook":
        return <Facebook />;

      case "Telegram":
        return <Telegram />;
    }
  }

  const [loading, setLoading] = useState(false);

  // Nova Conversa
  const startNovoChat = async (media) => {
    setLoading(true);

    try {
      const response = await api.post("/users/novo/chat/" + idCustomer, { social_media: media }, { headers: { "Authorization": "Bearer " + user.token } });

      fetchMessagesById(response.data.chat_id, idCustomer, user.currentAdmin_id, 1);
      handleChatBack();
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Popup title="Filtrar por rede social" trigger={trigger} setTrigger={setTrigger} >
      <div className="sm-body">
        <form onSubmit={handleSubmit(onSubmit)}>
          {loading && <LoadingCenter />}

          {!loading && <div className="row-grid">
            {socialMedias.map((media, index) => {
              return (
                <SocialMediaUser title={media} name="social_media" value={media} register={register} >
                  {getMediaType(media)}
                </SocialMediaUser>
              )
            })}
          </div>}

          <div className="popup-footer">
            <button className="btn btn-primary" type="submit">Concluir</button>
            <button className="btn btn-light mr-20" type="submit" onClick={() => setTrigger(false)}>Cancelar</button>
          </div>
        </form>
      </div>
    </Popup>
  );
}

export default PopupSocialMediaUserId;